<template>
  <div>
    <mobile-top :pro-name="pro_name" :logo='logo'></mobile-top>
    <vue-signature v-bind:is-show-sign.sync="isShowSign" @set-sign="setElectronicSignatureFile"></vue-signature>
    <div class="ncont detail" v-if="flow==0">
      <div class="sign-row center-row">
        <a class="sub-button" href="javascript:;" @click="flow=1">立即报名</a>
        <a class="sub-button" href="javascript:;" @click="flow=2">报名查询</a>
      </div>
    </div>
    <div v-else-if="flow==1" class="ncont detail">
      <div class="sign-row">
        <div class="label">
          <label>级别<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <select class="content-select" v-model="info.train_level">
              <option value="">请选择</option>
              <option v-for="(item,index) in listData.train_level" :value="index">{{item}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sign-row sign-row26" v-for="(item,index) in listData['apply_condition'][info.train_level]">
        <div class="">
          <div class="content-item">
            <input v-model="info.apply_condition" type="radio" :value="index" style="height: 5.52vw;width:5.52vw;flex-grow: 0;flex-shrink: 0;"/><span>{{item}}</span>
          </div>
        </div>
      </div>

      <div class="hr-div"></div>

      <div class="sign-row">
        <div class="label">
          <label>姓名<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input class="content-select" v-model="info.nm" />
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>证件类型<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <select class="content-select" v-model="info.cid_type">
              <option value="">请选择</option>
              <option v-for="(item,index) in listData.cid_type" :value="index">{{item}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>证件号<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input class="content-select" v-model="info.cid" @blur="changeCidInput"/>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>性别<span class="content-msg">（<span style='color: red;'>*</span>非身份证类型者必填）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <select class="content-select" v-model="info.gender">
              <option value="">请选择</option>
              <option v-for="(item,index) in listData.promotion_gender" :value="index">{{item}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>出生日期<span class="content-msg">（<span style='color: red;'>*</span>非身份证类型者必填）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input type="date" class="content-select" v-model="info.birthday"/>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>民族<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <select class="content-select" v-model="info.nation">
              <option value="">请选择</option>
              <option v-for="(item,index) in listData.nation" :value="index">{{item}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>政治面貌<span style='color: red;'>*</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <select class="content-select" v-model="info.political_outlook">
              <option value="">请选择</option>
              <option v-for="(item,index) in politic_status" :value="index">{{item}}</option>
            </select>
            <span class="content-msg"></span>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>文化程度<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <select class="content-select" v-model="info.edu_level">
              <option value="">请选择</option>
              <option v-for="(item,index) in listData.edu_level" :value="index">{{item}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>手机号码<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input class="content-select" v-model="info.mobile" />
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>考生来源<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <select class="content-select" v-model="info.source">
              <option value="">请选择</option>
              <option v-for="(item,index) in listData.source" :value="index">{{item}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>所在单位<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input class="content-select" v-model="info.company"/>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>通讯地址<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input class="content-select" v-model="info.address2"/>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>本职业工作年限<span class="content-msg">（<span style='color: red;'>*</span>必填项,时间日期可手动输入）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input type="month" class="content-select content-select3" v-model="info.career_start" @change="changeCareer" />
            <input class="content-select content-select3" type="text" v-model="info.career_years" readonly/>

            <!--                <label class="insert-label">至</label>-->
            <!--                <input type="month" class="content-select content-select3" />-->
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>电子邮箱<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item">
            <input class="content-select" v-model="info.email"/>
          </div>
        </div>
      </div>

      <div class="sign-row">
        <div class="label">
          <label>电子签名<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
        </div>
        <div class="content">
          <div class="content-item signature" @click="isShowSign=true">
            <input type="checkbox" class="content-select" style="width: 7.82vw" v-model="!!info.electronic_signature"/>
            <img v-if="info.electronic_signature" :src="electronic_signature_jpg" style="width: 62.58vw;height: 41.4vw;flex-grow: 1;"/>
          </div>
        </div>
      </div>
      <template  v-if="!(info.train_level == 5 || (info.train_level == 4 && (info.apply_condition == 2 || info.apply_condition == 3)) || !info.train_level || !info.apply_condition)">
        <div class="sign-row">
          <div class="label">
            <label>现有资格证书号码<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
          </div>
          <div class="content">
            <div class="content-item">
              <input class="content-select" v-model="info.cert_info"/>
            </div>
          </div>
        </div>
        <div class="sign-row">
          <div class="label">
            <label>现有证书工种名称<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
          </div>
          <div class="content">
            <div class="content-item">
              <!--                <input class="content-select" v-model="info.cert_nm"/>-->
              <select class="content-select" v-model="info.cert_nm">
                <option value="">请选择</option>
                <option v-for="item in cert_nm" :value="item">{{item}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="sign-row">
          <div class="label">
            <label>现有资格证书等级<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
          </div>
          <div class="content">
            <div class="content-item">
              <!--                <input class="content-select" v-model="info.cert_level"/>-->
              <select class="content-select" v-model="info.cert_level">
                <option value="">请选择</option>
                <option v-for="(item,index) in listData.train_level" :value="index">{{item}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="sign-row">
          <div class="label">
            <label>证书取得时间<span class="content-msg">（<span style='color: red;'>*</span>必填项）</span></label>
          </div>
          <div class="content">
            <div class="content-item">
              <input type="date" class="content-select" v-model="info.cert_date"/>

            </div>
          </div>
        </div>
      </template>

      <div class="sign-row" >
        <div class="label" style="vertical-align: top;">
          <label>证件照（<span style='color: red;'>*</span>必传）</label>
        </div>
        <div class="content">
          <div class="content-item">
            <upload :images="info.pic_passport" @update-image="getPassportFiles" @clear-image="clearPassportFiles" max-count="1" :param-width="'49.45vw'" :param-height="'69vw'"/>
          </div>
        </div>
        <span class="label warn-title">
          重要提示: <br>
          1.照片必需是近期、正面、免冠、白底、清晰的本人证件照；（拒绝使用扫描、PS等处理过的图片）。<br>
          2.照片格式应为JPG或JPEG格式，且以考生证件号码加姓名为名字，如“证件号码_张三.jpg”，文件大于30K且小于2M，大于215*300（宽*高）像素。<br>
          3.照片将用于证书打印，照片不符合以上要求将无法通过资格复审。
        </span>
      </div>
      <div class="sign-row" v-if="info.cid_type>''">
        <div class="label">
          <label>{{listData.cid_type[info.cid_type]}}正面（<span style='color: red;'>*</span>必传）</label>
        </div>
        <div class="content">
          <div class="content-item">
            <upload :images="info.pic_cid" @update-image="getCidFiles" @clear-image="clearCidFiles" max-count="1" param-width="300px" param-height="215px"/>
          </div>
        </div>
        <span class="label warn-title">
          重要提示: <br>
          文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边。
        </span>
      </div>
      <div class="sign-row" v-if="info.cid_type>''">
        <div class="label">
          <label>{{listData.cid_type[info.cid_type]}}反面（<span style='color: red;'>*</span>必传）</label>
        </div>
        <div class="content">
          <div class="content-item">
            <upload :images="info.pic_cid_back" @update-image="getCidFilesBack" @clear-image="clearCidFilesBack" max-count="1" param-width="300px" param-height="215px"/>
          </div>
          <span class="label warn-title">
            重要提示: <br>
            文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边。
          </span>
        </div>
      </div>

      <div class="sign-row" v-if="info.edu_level>2">
            <div class="label">
              <label>学历证书</label>
            </div>
            <div class="content">
              <div class="content-item">
                <upload :images="info.pic_edu" @update-image="getEduFiles" @clear-image="clearEduFiles" max-count="1" />
                <!--                <input ref="fileEducation" type="file" @change="getEduFiles($event)" accept="image/*"/>-->
                <!--                <input type="text" class="content-select" disabled :value="(fileEducation!='')?fileEducation:info.pic_edu" />-->
                <!--                <a class="changeButton" href="javascript:;" @click="changeEducation">上传</a>-->
                <span class="content-msg">（<span
                    style='color: red;'>*</span>必填项，文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边）</span>
              </div>
            </div>
          </div>

      <div class="sign-row" v-if="!(info.train_level == 5 || (info.train_level == 4 && (info.apply_condition == 2 || info.apply_condition == 3)) || !info.train_level || !info.apply_condition) && (info.cert_info>'' || info.cert_nm>'')">
        <div class="label">
          <label>原资格证书（<span style='color: red;'>*</span>必传）</label>
        </div>
        <div class="content">
          <div class="content-item">
            <upload :images="info.pic_career_cert" @update-image="getQuaFiles" @clear-image="clearQuaFiles" max-count="3"/>
          </div>
          <span class="label warn-title">
            重要提示: <br>
            文件大于30K且小于2M，图像清晰，不要歪斜、扭曲，四周不留杂边
          </span>
        </div>
      </div>

      <div class="sign-col center-row" v-if="info.id">
        <button href="javascript:;" v-if="info.status == 1" style="background: #9facb7;border-color: #9facb7;">已通过审核</button>
        <button href="javascript:;" @click="submitSign(1)" v-else>立即修改</button>
      </div>
      <div class="sign-col center-row" v-else>
        <button href="javascript:;" @click="submitSign(1)" v-if="cansub == 1">立即报名</button>
        <button href="javascript:;" v-else>立即报名</button>
        <button href="javascript:;" @click="submitSign(2)">保存草稿</button>
      </div>
    </div>
    <div class="ncont detail" v-if="flow==2">
      <div class="sign-row">
          <label>请输入手机号</label>
          <input class="content-select" v-model="search_code"/>
      </div>
      <div class="sign-col center-row">
        <button @click="searchSign">立即查询</button>
        <button @click="flow=0">返回</button>
      </div>
      <div class="result-sign" v-show="showsearchData == 1">
        <div class="result-sign-item">
          {{searchDataName}}
          <span v-if="searchData.status==1" style="color: green;">(审核通过)</span>
          <span v-else-if="searchData.status==2" style="color: red;">(审核未通过<span v-if="searchData.memo">,{{searchData.memo}}</span>)</span>
          <span v-else-if="searchData.save==2" style="color: red;">(草稿)</span>
          <span v-else style="color: red;">(审核中)</span>
        </div>
        <div v-if="searchData.status==2" class="fs14 lh20">
          <div  v-for="(item,index) in searchData.refuseReasonsStringArray">{{index + 1}}. {{item}}</div>
        </div>
        <!-- <div v-for="(item,index) in searchData" @click="selectSearch(index)" class="result-sign-item">
          {{item.discipline.name}}
          <span v-if="item.save==1" style="color: green;">(已报名)</span>
          <span v-else style="color: red;">(草稿)</span>
          <span v-if="item.status==1" style="color: green;">(已通过)</span>
          <span v-else-if="item.status==2" style="color: red;">(未通过，{{item.memo}})</span>
          <span v-else style="color: red;">(待审核)</span>
        </div> -->
      </div>
    </div>
    <div class="ncont detail" v-if="flow==3">
      <div class="sign-col center-row success-div">
        <span class="success-title">操作成功！请通过您手机号进行查询：{{info.mobile}}</span>
      </div>
      <div class="sign-col center-row">
        <div class="sub-button" @click="flow=0">返回首页</div>
      </div>

    </div>
    <mobile-bottom :site-name="site_name"></mobile-bottom>
  </div>
</template>

<script>
import MobileTop from '../top'
import MobileBottom from '../bottom'
import Upload from '../../../item/upload'
import vueSignature from '../../../item/vueSignatureMobile'
export default {
  name: 'sign',

  components: {
    MobileTop,
    MobileBottom,
    Upload,
    vueSignature
  },

  data () {
    return {
	  'logo': '',
      'cansub': 1,
      'id': 0,
      'project_id': 0,
      'showsearchData': 0,
      'searchDataName': '',
      'search_code': '',
      'flow': 0,
      'pro_name': '',
      'site_name': '',
      'info': {
        'id': '',
        'train_id': 0,
        'train_level': '',
        'apply_condition': '',
        'nm': '',
        'cid_type': '',
        'cid': '',
        'birthday': '',
        'gender': 0,
        'nation': '',
        'edu_level': '',
        'mobile': '',
        'source': '',
        'company': '',
        'address2': '',
        'career_start': '',
        'career_years': '',
        'email': '',
        'cert_info': '',
        'cert_nm': '',
        'pic_career_cert': '',
        'pic_cid': '',
        'pic_passport': '',
        'pic_cid_back': '',
        'pic_edu': '',
        'save': 0,
        'cert_level': '',
        'cert_date': '',
        'electronic_signature': '',
        'political_outlook': ''
      },
      'cert_nm': [],
      'cidFiles': [],
      'cidFilesBack': [],
      'passportFiles': [],
      'filePassport': '',
      'eduFiles': [],
      'quaFiles': [],
      'fileEducation': '',
      'fileCid': '',
      'fileCidBack': '',
      'fileQualifications': '',
      'listData': [],
      'searchData': [],
      'isShowSign': false,
      'electronicSignatureFile': '',
      'electronic_signature_jpg': '',
      'edu_list': [],
      'politic_status': []
    }
  },

  created () {
	  //document.title = ''
	  this.getLogo()
    this.pro_name = this.$route.query.name
    this.info.train_id = this.$route.query.id
    this.id = this.$route.query.id
    this.project_id = this.$route.query.project_id
    if (this.$request.isPc()) {
      this.$router.push({
        path: '/train/project/sign', 
        query: {
          name: this.pro_name, 
          id: this.id, 
          //train_id: this.info.train_id
          project_id: this.project_id,
        }
      })
    }
    var itemJnNameSelect = this.$route.query.work_option
    if (itemJnNameSelect) {
      this.cert_nm = itemJnNameSelect && itemJnNameSelect.split(',')
    }
    this.getData()
  },

  methods: {
	  getLogo(){
       this.$request.getSims('site/school-info', {}, response => {
        if (response.status == 200 && response.data.code == 200) {
          let data = response.data.data
		      this.logo = data.logo
          document.title = data.site_name
          this.site_name = data.site_name
        }
      }, error => {
        // document.title = 'zhang'
        // this.logo = 'https://fs.cjnep.net/resources/kaifa/sims/logo.png'
        console.log(error)
      })
    },
    selectSearch: function (index) {
      this.info = this.searchData[index]
      this.id = this.info.disc_id
      this.pro_name = this.info.discipline.name
      this.flow = 1
      this.electronic_signature_jpg = this.$request.file_server + this.info.electronic_signature
    },
    changeCareer: function () {
      var car = this.info.career_start.split('-')
      console.log(car)
      if (car.length > 1) {
        var year = parseInt(car[0])
        var month = parseInt(car[1])
        var date = new Date()
        var now_year = date.getFullYear()
        if (month > 6 && now_year <= 6) {
          this.info.career_years = now_year - year - 1
        } else {
          this.info.career_years = now_year - year
        }
      }
    },
    getBirth: function (idCard) {
      var birthday = ''
      if (idCard != null && idCard != '') {
        if (idCard.length == 15) {
          birthday = '19' + idCard.slice(6, 12)
        } else if (idCard.length == 18) {
          birthday = idCard.slice(6, 14)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
        // 通过正则表达式来指定输出格式为:1990-01-01
      }
      return birthday
    },
    getSex: function (idCard) {
      var sexStr = ''
      if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
        sexStr = 1
      } else {
        sexStr = 0
      }
      return sexStr
    },
    isCard: function (str) {
      var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
      return reg.test(str)
    },
    isPhone: function (str) {
      var reg = /(^1\d{10}$)/
      return reg.test(str)
    },
    changeCidInput: function () {
      if (this.info.cid_type == 1) {
        if (this.isCard(this.info.cid)) {
          this.info.birthday = this.getBirth(this.info.cid)
          this.info.gender = this.getSex(this.info.cid)
        } else {
          alert('不是正确的身份证格式')
        }
      }
       this.changeCidSearch();
    },
    getData: function () {
      this.$request.get('training-skill/skill-appraisal-options', {}, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.listData = response.data.data
          this.edu_list = response.data.data.edu_level
          this.politic_status = response.data.data.politic_status
        }
      }, error => {
        console.log(error)
      })
    },
    getPassportFiles: function (e) {
      this.passportFiles = e.target.files
      this.filePassport = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.filePassport += e.target.files[i]['name'] + ';'
      }
    },
    clearPassportFiles: function (e) {
      this.passportFiles = []
      this.filePassport = ''
    },
    getCidFiles: function (e) {
      this.cidFiles = e.target.files
      this.fileCid = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileCid += e.target.files[i]['name'] + ';'
      }
    },
    clearCidFiles: function (e) {
      this.cidFiles = []
      this.fileCid = ''
    },

    getCidFilesBack: function (e) {
      this.cidFilesBack = e.target.files
      this.fileCidBack = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileCidBack += e.target.files[i]['name'] + ';'
      }
    },
    clearCidFilesBack: function (e) {
      this.cidFilesBack = []
      this.fileCidBack = ''
    },
    getEduFiles: function (e) {
      this.eduFiles = e.target.files
      this.fileEducation = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileEducation += e.target.files[i]['name'] + ';'
      }
    },
    clearEduFiles: function (e) {
      this.eduFiles = []
      this.fileEducation = ''
    },

    getQuaFiles: function (e) {
      this.quaFiles.push(
        e.target.files[0]
      )
      this.fileQualifications = ''
      for (let i = 0; i < e.target.files.length; i++) {
        this.fileQualifications += e.target.files[i]['name'] + ';'
      }
    },
    clearQuaFiles: function (index) {
      var pic_cer = this.info.pic_career_cert
      var pic_cer_arr = pic_cer.split(';')
      pic_cer_arr.splice(index, 1)
      this.info.pic_career_cert = pic_cer_arr.join(';')
      this.quaFiles.splice(index, 1)
      this.fileQualifications = ''
      for (let i = 0; i < this.quaFiles.length; i++) {
        this.fileQualifications += this.quaFiles[i]['name'] + ';'
      }
    },
    setElectronicSignatureFile: function (e, f) {
      this.electronicSignatureFile = e
      this.info.electronic_signature = 'signature.jpg'
      this.electronic_signature_jpg = f
    },
    submitSign: function (save) {
      this.info.save = save
      if (!this.info.nm) {
        alert('姓名不能为空'); return false
      }
      if (!this.info.cid_type) {
        alert('证件类型不能为空'); return false
      }
      if (!this.info.cid) {
        alert('证件号不能为空'); return false
      }
      if (!this.info.mobile) {
        alert('手机号不能为空'); return false
      }
      /*
      if(!this.info.gender){
        alert('性别不能为空');return false;
      } */
      if (!this.info.birthday) {
        alert('出生日期不能为空'); return false
      }
      if (!this.info.nation) {
        alert('民族不能为空'); return false
      }
      if (!this.info.political_outlook) {
        alert('政治面貌不能为空'); return false
      }
      if (!this.info.edu_level) {
        alert('文化程度不能为空'); return false
      }
      if (!this.info.source) {
        alert('考生来源不能为空'); return false
      }
      if (!this.info.company) {
        alert('所在单位不能为空'); return false
      }
      if (!this.info.address2) {
        alert('通讯地址不能为空'); return false
      }
      if (!this.info.career_start && save == 1) {
        alert('工作年限不能为空'); return false
      }
      if (!this.info.email && save == 1) {
        alert('电子邮箱不能为空'); return false
      }
      if (this.info.cid_type == 1 && !this.isCard(this.info.cid)) {
        alert('身份证格式错误'); return false
      }
      if (!this.isPhone(this.info.mobile)) {
        alert('手机号格式错误'); return false
      }
      if (!this.info.electronic_signature && save == 1) {
        alert('未签名'); return false
      }
      if (save == 1) {
        if (this.id == '' || this.id == 0) {
          alert('未关联项目'); return false
        }
		let flag = this.info.train_level == 1 || this.info.train_level == 2 || this.info.train_level == 3
        //if (this.info.train_level == 1 || this.info.train_level == 2 || this.info.train_level == 3) {
		if (flag) {
          if (!this.info.cert_info || !this.info.cert_nm) {
            alert('证书名称，证书号不能为空'); return false
          }
        }
        if (this.info.train_level == 4 && this.info.apply_condition == 1) {
          if (!this.info.cert_info || !this.info.cert_nm) {
            alert('证书名称，证书号不能为空'); return false
          }
        }
        if (!this.info.pic_passport && !this.filePassport) {
          alert('证件照未上传'); return false
        }
        if (this.info.cid_type > '') {
          if (!this.info.pic_cid && !this.fileCid) {
            alert(this.listData.cid_type[this.info.cid_type] + '正面未上传'); return false
          }
          if (!this.info.pic_cid_back && !this.fileCidBack) {
            alert(this.listData.cid_type[this.info.cid_type] + '反面未上传'); return false
          }
        }
        if (this.info.edu_level >= 3) {
          if (!this.info.pic_edu && !this.fileEducation) {
            alert('学历证书未上传')
            return false
          }
        }
        if (flag && !(this.info.cert_info == '' && this.info.cert_nm == '')) {
          if (!this.info.pic_career_cert && !this.fileQualifications) {
            alert('资格证书未上传'); return false
          }
        }
      }
      let param = new FormData()
      if (this.electronicSignatureFile) {
        param.append('electronic_signature', this.electronicSignatureFile, 'signature.jpg')
      }
      if (this.passportFiles.length > 0) {
        param.append('pic_passport', this.passportFiles[0], this.passportFiles[0].name)
      }
      if (this.cidFiles.length > 0) {
        param.append('pic_cid', this.cidFiles[0], this.cidFiles[0].name)
      }
      if (this.cidFilesBack.length > 0) {
        param.append('pic_cid_back', this.cidFilesBack[0], this.cidFilesBack[0].name)
      }
      if (this.eduFiles.length > 0) {
        param.append('pic_edu', this.eduFiles[0], this.eduFiles[0].name)
      }
      if (this.quaFiles.length > 0) {
        for (let i = 0; i < this.quaFiles.length; i++) {
          param.append('pic_career_cert[]', this.quaFiles[i], this.quaFiles[i].name)
        }
      }
      for (let key in this.info) {
        param.append(key, this.info[key])
      }
      // param.append('discipline_id', this.id)
      // param.append('train_id', this.info.train_id)

      param.append('class_id', this.id)
      param.append('discipline_id', this.project_id)

      let config = {
        headers: {'Content-Type': 'multipart/form-data'}
      } // 添加请求头
      this.cansub = 0
      this.$request.postFile('training-skill/skill-appraisal-enroll', param, config, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.cansub = 1
          // 报名成功
          if (save == 2) {
            this.flow = 3
          } else {
            this.flow = 3
          }
        } else {
          this.cansub = 1
          alert(response.data.message)
        }
      }, error => {
        console.log(error)
      })
    },
    changeCid: function () {
      this.$refs.fileCid.dispatchEvent(new MouseEvent('click'))
    },
    changeEducation: function () {
      this.$refs.fileEducation.dispatchEvent(new MouseEvent('click'))
    },
    changeQualifications: function () {
      this.$refs.fileQualifications.dispatchEvent(new MouseEvent('click'))
    },
    searchSign: function () {
      if (this.id == '' || this.id == 0) {
        alert('未关联项目'); return false
      }
      // var param = {
      //   search_code: this.search_code,
      //   train_id: this.info.train_id
      // }
      var param = {
        search_code: this.search_code,
        class_id: this.id,
        train_id: this.project_id
      }

      this.$request.get('training-skill/get-skill-appraisal-record', param, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.searchData = response.data.data
          this.searchDataName = response.data.data.discipline.name
          this.showsearchData = 1
          // this.flow = 1;
        } else {
          alert('未报名')
        }
      }, error => {
        console.log(error)
      })
    },
    changeCidSearch: function () { 
      //查询报名记录
      var param = {
        class_id: this.id,
        train_id: this.project_id,
        cid_type: this.info.cid_type,
        cid: this.info.cid,
      }
      this.$request.get('training-skill/get-skill-appraisal-record-by-cid', param, response => {
        if (response.status == 200 && response.data.code == 200) {
          this.info = response.data.data
          // this.flow = 1;
         } //else {
        //   alert('未报名')
        // }
      }, error => {
        console.log(error)
      })
    }
  }
}
</script>

<style scoped>
.ncont{
  width: 100vw;
  min-height: 143vw;
  background-color: #fff;
}
.sign-row{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sign-row .content-select{
  border: 0.23vw solid #d3d9dd;
  background-color: #f3f3f3;
}
.sign-row .content-select,.sign-row .content{
  box-sizing: border-box;
  width:81.88vw;
  min-height: 7.82vw;
}
.sign-row label{
  margin-top: 14.26vw;
}
.sign-row label,.sign-row .label{
  min-height: 9.2vw;
  width: 80.04vw;
  line-height: 9.2vw;
  font-size: 3.68vw;
  color: #666666;
}
.sub-button{
  box-sizing: border-box;
  width: 80.04vw;
  height: 17.94vw;
  background-color: #e3edf6;
  color: #147ad8;
  font-size: 5.52vw;
  text-align: center;
  line-height: 17.94vw;
  border-radius: 1.38vw;
}
.sub-button:nth-child(1){
  margin-top: 26.22vw;
}
.sub-button:nth-child(2){
  margin-top: 7.36vw;
}
.sign-col{
  width:81.88vw;
  display: flex;
  flex-direction: row;
  height: 34.5vw;
  justify-content: space-between;
  align-items: center;
  margin: auto
}
.sign-col button{
  box-sizing: border-box;
  width: 37.26vw;
  height: 11.04vw;
  border: #147ad8 solid 0.46vw;
  border-radius: 1.38vw;
  font-size: 4.14vw;
}
.sign-col button:nth-child(1){
  background-color: #147ad8;
  color: #fff;
}
.sign-col button:nth-child(2){
  background-color: #fff;
  color: #147ad8;
}
.result-sign{
  width: 81.88vw;
  margin: auto;
  display: flex;
  flex-direction: column;
}
.result-sign-item{
  display: flex;
  font-size: 3.68vw;
}
.result-sign-item::before{
  content: '';
  width: 4.38vw;
  background-image: url("../../../../assets/images/jt.png");
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 1vw;
}
.hr-div{width: 100%;height: 1px;border-top: 0.3vw solid rgb(233,233,233);margin: 6vw 0}
.content-item{
  width: 80.04vw;
  display: flex;
  flex-direction: row;
}
.sign-row26{
  margin-top: 4.6vw;
}
.label.warn-title{
  font-size: 3.22vw;
  color: #94070a;
  line-height: 4.6vw;
}
.success-div{
  height: 60.5vw;
}
.success-title{
  font-size: 5vw;
}
.signature{
  position: relative;
}
.signature::before{
  content: '';
  display: block;
  z-index: 100;
  width: 100%;
  height: 100%;
  position: absolute;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/train/project/sign.vue